import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Castr from "./Castr";
import Bunny from "./Bunny";
import CastrTablet from "./CastrTablet";

const router = createBrowserRouter([
  {
    path: "/video/baghdadapp/:videoURL",
    element: <App />,
  },
  {
    path: "/video/bunny/:cdnHostname/:bunnyID",
    element: <Bunny />,
  },
  {
    path: "/video/baghdadapp/castr/:videoURL",
    element: <Castr />,
  },
  {
    path: "/video/baghdadapp/castrtab/:videoURL",
    element: <CastrTablet />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
